import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../utility';

const initialState = {
	data: [],
	loading: false,
};

const getO2PurityStart = (state) => {
	return updateObject(state, { loading: true });
};

const getO2PuritySuccess = (state, action) => {
	return updateObject(state, {
		data: action.data,
		loading: false,
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_O2_PURITY_START:
			return getO2PurityStart(state);
		case actionTypes.GET_O2_PURITY_SUCCESS:
			return getO2PuritySuccess(state, action);

		default:
			return state;
	}
};

export default reducer;
